export default __webpack_public_path__ + "static/media/csharp.34f2460d.png";